let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jxu37")).then(() => parcelRequire('2ob2Z'));